import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';
import { PriceRuleDrawerAction } from '../../components/ListViewCustomComponents';
import { PriceRule } from '../../models/stack9/PriceRule';

const Drawer = PriceRuleDrawerAction.default;

type Props = {
  countrySetupId: number;
  initialValues?: Partial<PriceRule>;
};
const PriceRuleInfo = ({ countrySetupId, initialValues }: Props) => {
  const columns: ColumnConfiguration[] = [
    {
      label: 'Org size',
      field: 'organisation_size',
      renderAs: ColumnConfigurationRenderAs.CustomComponent,
      value: '{{organisation_size}}',
      options: {
        customComponentName: 'PriceRuleDrawerAction',
      },
    },
    {
      label: 'Currency',
      field: 'currency',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{currency}}',
    },
    {
      label: 'Amount',
      field: 'amount',
      renderAs: ColumnConfigurationRenderAs.Decimal,
      value: '{{amount}}',
      options: {
        prefix: '$',
      },
    },
    {
      label: 'Period start date',
      field: 'period_start_dt',
      renderAs: ColumnConfigurationRenderAs.Date,
      value: '{{period_start_dt}}',
      options: {
        noTime: true,
      },
    },
    {
      label: 'Period end date',
      field: 'period_end_dt',
      renderAs: ColumnConfigurationRenderAs.Date,
      value: '{{period_end_dt}}',
      options: {
        noTime: true,
      },
    },
  ];

  return (
    <ListTable
      queryVars={{ countrySetupId }}
      columns={columns}
      title="Price rules"
      queryName="getpriceruleslistbycountrysetup"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Drawer row={{ ...initialValues }} />
      </div>
    </ListTable>
  );
};

export default PriceRuleInfo;
